module.exports = __webpack_public_path__ + "img/front_rise.4a83c860.png";